import { Pipe, PipeTransform } from '@angular/core';
import { CaseRequest } from '@shared/models';

@Pipe({
  name: 'caseRequest',
  standalone: true
})
export class CaseRequestPipe implements PipeTransform {
  transform(id: string | undefined, caseRequests: CaseRequest[]): boolean {
    return !!caseRequests.find(caseRequest => caseRequest.id === id);
  }
}
